/// Handles a synchronous message queue over a websocket.
/// If errors ocurr the websocket connection will be retried using an exponential backoff.
export class Socket {
    constructor(url) {
        this.backoff = 0;
        this.onmessage = null;
        this.pendingMessages = [];
        this.retrying = false;
        this.messageInFlight = false;
        this.url = url;
        this.socket = new WebSocket(url);
        this.resetBackoff();
        this.initializeSocket();
    }
    initializeSocket() {
        this.socket.onmessage = (e) => {
            if (!this.messageInFlight) {
                console.error("Received message from server even though we didn't expect one.", e);
            }
            else {
                this.resetBackoff();
                this.messageInFlight = false;
                console.assert(this.pendingMessages.length > 0);
                const msg = this.pendingMessages.shift();
                if (msg === undefined) {
                    throw "Expected a pending message";
                }
                msg.response(e.data);
                // Check if there are any other messages we want to send
                this.retry();
            }
        };
        this.socket.onopen = (_) => {
            this.retry();
        };
        this.socket.onerror = (_) => {
            if (this.pendingMessages.length > 0) {
                this.retry();
            }
        };
    }
    resetBackoff() {
        this.backoff = 100;
    }
    send(data) {
        var p = new Promise((resolve, reject) => {
            this.pendingMessages.push({
                data,
                response: resolve,
            });
        });
        this.retry();
        return p;
    }
    retry() {
        if (this.socket.readyState == WebSocket.CLOSING || this.socket.readyState == WebSocket.CLOSED) {
            if (!this.retrying) {
                this.retrying = true;
                console.log(`Socket is dead. Re-trying in ${this.backoff} ms`);
                setTimeout(() => {
                    console.assert(this.retrying);
                    this.retrying = false;
                    // Clear previous callbacks just in case they would get triggered again
                    this.socket.onmessage = null;
                    this.socket.onopen = null;
                    this.socket.onerror = null;
                    this.socket = new WebSocket(this.url);
                    // Re-send previous in flight messages
                    this.messageInFlight = false;
                    this.initializeSocket();
                }, this.backoff);
                this.backoff = Math.min(this.backoff * 2, 5 * 60000);
            }
        }
        else if (this.socket.readyState == WebSocket.CONNECTING) {
            // Retry will be called when the socket has been opened
        }
        else {
            console.assert(this.socket.readyState == WebSocket.OPEN);
            if (!this.messageInFlight && this.pendingMessages.length > 0) {
                this.socket.send(this.pendingMessages[0].data);
                this.messageInFlight = true;
            }
        }
    }
}
